import { render, staticRenderFns } from "./HealentScore.vue?vue&type=template&id=07fa386c&"
import script from "./HealentScore.vue?vue&type=script&lang=js&"
export * from "./HealentScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports